import { AdminBannerStatus } from '../enums/admin-banner-status';
import { Guid, Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { BannerLocationType } from '../../shared/enums/banner-location-type';

export class AdminBannerCollectionItem {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      createdAt: Nillable<Date>;
      file: Multimedia;
      id: Guid;
      location: BannerLocationType;
      status: AdminBannerStatus;
      url?: Nillable<string>;
      visibilityEndDate?: Nillable<Date>;
      visibilityStartDate?: Nillable<Date>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get status(): AdminBannerStatus {
    return this.data.status;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get createdAt(): Nillable<Date> {
    return this.data.createdAt;
  }

  public get location(): BannerLocationType {
    return this.data.location;
  }

  public get file(): Multimedia {
    return this.data.file;
  }

  public get visibilityStartDate(): Nillable<Date> {
    return this.data.visibilityStartDate;
  }

  public get visibilityEndDate(): Nillable<Date> {
    return this.data.visibilityEndDate;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }
}
